import { io, Socket } from "socket.io-client";
import { hasAnyFilter } from "./evidenceSocket";
import type { EvidenceEvent, EvidenceFilter } from "./evidenceSocket";

interface SubscribedEvidenceResponse {
  rooms: string[];
}

interface ServerToClientEvents {
  evidence: (ev: EvidenceEvent) => void;
  "subscribed:evidence": (response: SubscribedEvidenceResponse) => void;
}

interface ClientToServerEvents {
  "subscribe:evidence": (filter: EvidenceFilter) => void;
  "unsubscribe:evidence": (filter: EvidenceFilter) => void;
}

const EVIDENCE_SOCKET_URL =
  import.meta.env.VITE_DUMAX_EVIDENCE_SOCKET_URL ||
  "https://dumax-socket-oyni7keu3a-uc.a.run.app";

let socket: Socket<ServerToClientEvents, ClientToServerEvents> | null = null;

export const getModalEvidenceSocket = (): Socket<
  ServerToClientEvents,
  ClientToServerEvents
> => {
  if (!socket) {
    socket = io(EVIDENCE_SOCKET_URL, {
      transports: ["websocket"],
      autoConnect: false,
      forceNew: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 20000,
    });
  }
  return socket;
};

export const connectModalEvidenceSocket = (): Socket<
  ServerToClientEvents,
  ClientToServerEvents
> => {
  const socketInstance = getModalEvidenceSocket();
  if (!socketInstance.connected) {
    socketInstance.connect();
  }
  return socketInstance;
};

export const disconnectModalEvidenceSocket = (): void => {
  if (socket?.connected) {
    socket.disconnect();
  }
};

export const subscribeModalEvidence = (filter: EvidenceFilter): void => {
  if (!hasAnyFilter(filter)) return;
  getModalEvidenceSocket().emit("subscribe:evidence", filter);
};

export const unsubscribeModalEvidence = (filter: EvidenceFilter): void => {
  if (!hasAnyFilter(filter)) return;
  const socketInstance = getModalEvidenceSocket();
  if (!socketInstance.connected) return;
  socketInstance.emit("unsubscribe:evidence", filter);
};
